// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"styles__pageHeader___LQPSo","content":"styles__content___lzj6J"};